import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/page';

export default {
	/**
	 * Fetch All Pages
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getPages(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Fetch Page Detail
	 *
 	 * @param {Object} slug Slug
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getDetails(slug, cb, errorCb) {
		const url = `${endpoint}/${slug}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Store/Create Pages
	 *
	 * @param {Object} params
	 * @param {Object} params.title Title
	 * @param {string} params.slug Slug
	 * @param {string[]} params.cover Cover (Picture)
	 * @param {string} params.content Content
	 * @param {string[]} params.tag Tag
	 * @param {string} params.type Type => default "general"
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	store(params, cb, errorCb) {
		const url = `${endpoint}`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Delete
	 *
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete
	 *
	 * @param {Object} params
	 * @param {string[]} params.customer_ids Array of Contacts ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDelete(ids = [], cb, errorCb) {
		const url = endpoint;

		const idsJSON = JSON.stringify(ids);
		const params = {
			page_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Single Update Page
	 *
	 * @param {string} id Page ID
	 * @param {Object} params
	 * @param {Object} params.title Title
	 * @param {string} params.slug Slug
	 * @param {string[]} params.cover Cover (Picture)
	 * @param {string} params.content Content
	 * @param {string[]} params.tag Tag
	 * @param {string} params.type Type => default "general"
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

};
